import React, { useState } from 'react'
import { AiFillHome } from 'react-icons/ai'
import { GoBell } from 'react-icons/go'
import { BsFillPersonFill } from 'react-icons/bs'
import { BsFillBookmarkFill } from 'react-icons/bs'

const Sidebar = () => {
    const [nav, setnav] = useState(1)
    
    return (
        <div className="sondaria-side-bar">
            <div className="sidebar-profile-banner">
                <div className="profile-banner-image"></div>
                <div className="profile-banner-details">
                    <p>Marine_snchz</p>
                    <p className="profile-banner-details-green">Voir le profil</p>
                </div>
            </div>
            <div className="sidebar-nav-links">
                    <button
                        className={nav === 1 ? "sidebar-nav-links-active" : ""}
                        onClick={() => setnav(1)}>
                        <AiFillHome className="side-bar-icon" />
                        <p>Fil d’actualités</p>
                    </button>
                    <button
                        className={nav === 2 ? "sidebar-nav-links-active" : ""}
                        onClick={() => setnav(2)}>
                        <GoBell className="side-bar-icon" />
                        <p>Notifications</p>
                        <div className="red-notifaction-bubble">3</div>
                    </button>
                    <button
                        className={nav === 3 ? "sidebar-nav-links-active" : ""}
                        onClick={() => setnav(3)}>
                        <BsFillPersonFill className="side-bar-icon" />
                        <p>Profil</p>
                    </button>
                    <button
                        className={nav === 4 ? "sidebar-nav-links-active" : ""}
                        onClick={() => setnav(4)}>
                        <BsFillBookmarkFill className="side-bar-icon" />
                        <p>Enregistrés</p>
                    </button>



            </div>
        </div>
    )
}

export default Sidebar
